import { validateUUID } from '../../../../../../utils/validation';

export interface CloudInfraCredentials {
  clientId: string;
  secretKey: string;
  adminEmail: string;
}

export type CloudInfraField = keyof CloudInfraCredentials;

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isUuidValid = (uuid: string): boolean => validateUUID(uuid.trim());

export const isClientIdValid = (clientId: string): boolean =>
  clientId.trim().length > 0;

export const isSecretKeyValid = (secret: string): boolean =>
  secret.trim().length > 0;

export const isAdminEmailValid = (email: string): boolean =>
  EMAIL_REGEX.test(email.trim());
